export class MaterialIssueRequest{
    styleId: number

    constructor(
        styleId:number
    ){
        this.styleId = styleId
    }
}